<template>
<div class="chapter">
<div class="inner_page">
<p class="p6"><span class="t7">Dedication</span></p>
<p> </p>
<p> </p>
<p> </p>
<p class="p8">For Stacia, </p>
<p class="p8">without whose constant support</p>
<p class="p8">and encouragement this book </p>
<p class="p8">never would have happened.</p>
<p class="p8"> </p>
<p class="p8">And for Elizabeth North:</p>
<p class="p8">Thank you for being a constant source </p>
<p class="p8">of light when all the others disappeared.</p>
<p class="p8"> </p>
<p class="p8">A special thank you to Mickie B. Ashling, </p>
<p class="p8">Zahra Owens, and Christopher Koehler </p>
<p class="p8">for giving so freely of their time and expertise.</p>
<p> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 006.vue?44773f4c